"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotifiSubscriptionContext = exports.NotifiSubscriptionContextProvider = void 0;
const react_1 = __importStar(require("react"));
const NotifiSubscriptionContext = (0, react_1.createContext)({});
const NotifiSubscriptionContextProvider = (_a) => {
    var _b;
    var { children } = _a, params = __rest(_a, ["children"]);
    const [email, setEmail] = (0, react_1.useState)('');
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const [telegramId, setTelegramId] = (0, react_1.useState)('');
    const [telegramConfirmationUrl, setTelegramConfirmationUrl] = (0, react_1.useState)(undefined);
    const [alerts, setAlerts] = (0, react_1.useState)({});
    const [useHardwareWallet, setUseHardwareWallet] = (0, react_1.useState)(false);
    const alertConfigurations = (0, react_1.useRef)((_b = params.alertConfigurations) !== null && _b !== void 0 ? _b : {});
    const getAlertConfigurations = (0, react_1.useCallback)(() => {
        return alertConfigurations.current;
    }, []);
    const getAlertConfiguration = (0, react_1.useCallback)((name) => {
        var _a;
        return (_a = alertConfigurations.current[name]) !== null && _a !== void 0 ? _a : null;
    }, []);
    const setAlertConfiguration = (0, react_1.useCallback)((name, config) => {
        if (config === null) {
            alertConfigurations.current[name] = null;
        }
        else {
            alertConfigurations.current[name] = config;
        }
    }, []);
    const value = {
        alerts,
        email,
        params,
        phoneNumber,
        telegramId,
        telegramConfirmationUrl,
        useHardwareWallet,
        getAlertConfiguration,
        getAlertConfigurations,
        setAlerts,
        setAlertConfiguration,
        setEmail,
        setPhoneNumber,
        setTelegramId,
        setTelegramConfirmationUrl,
        setUseHardwareWallet,
    };
    return (react_1.default.createElement(NotifiSubscriptionContext.Provider, { value: value }, children));
};
exports.NotifiSubscriptionContextProvider = NotifiSubscriptionContextProvider;
const useNotifiSubscriptionContext = () => {
    const data = (0, react_1.useContext)(NotifiSubscriptionContext);
    return data;
};
exports.useNotifiSubscriptionContext = useNotifiSubscriptionContext;
//# sourceMappingURL=data:application/json;base64,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